import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User toggled email digest off',
  name: 'toggled_email_digest_off',
};

export default META;
